export const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
};
